const API_BASE_URL = 'https://api.worldadventurestours.com/api';
const IMAGE_BASE_URL = 'https://api.worldadventurestours.com/uploads';
const TINY_MCE_API_KEY="5u39n40hceldjr6v6it1r4kovyiejamaqx7ng6ddjbwbx5nm";
const VITE_STRIPE_PUBLISHABLE_KEY="pk_live_51SpZ9xKQdkLmXGqkPoEgK7jWsOAtEZxNJByP8wmDuvJHMlaUf2ucQ9jensR6TsCyvN9Ys047MucPXOLnUbuZ4s1p00PmEMtEUF"
const VITE_STRIPE_PUBLISHABLE_KEY_TEST="pk_test_51SpZ9xKQdkLmXGqkF3v1fuArNKlCqZeRelcL0X7mWsqpq1IepdSALTGh1YiCGU6NdMepZCs5VP0h9K5vYQxDnDcr00oi1Xiq5D"

export { API_BASE_URL, IMAGE_BASE_URL, TINY_MCE_API_KEY, VITE_STRIPE_PUBLISHABLE_KEY, VITE_STRIPE_PUBLISHABLE_KEY_TEST };